import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import { Card, CardContent, Grid, Typography, Avatar, CircularProgress } from '@material-ui/core';
import { Storage } from '@material-ui/icons';
import { colors } from '@material-ui/core';

const styles = theme => ({
  root: {
    height: '100%',

  },
  content: {
    alignItems: 'center',
    display: 'block'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.success.dark,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: colors.green[900]
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  },
  typography: {
    color: colors.blueGrey[900],
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px'
  }
});

const ErasedStorages = props => {
  const { className, classes, loading, numberOfStorages, ...rest } = props;


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {props.translations['erased'] || "ERASED"}
            </Typography>
            {loading ? <CircularProgress size={20} /> : <Typography className={classes.typography}> {numberOfStorages} </Typography>}
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <Storage className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};



export default withStyles(styles, { withTheme: true })(ErasedStorages);
